import { SentryErrorQueue } from './errorQueue';

export function setupResourceErrorHandlers() {
    window.addEventListener('error', (event) => {
        if (event.target && ['IMG'/*, 'SCRIPT', 'LINK'*/].includes(event.target.tagName)) {
            const errorData = {
                type: 'message',
                message: `Failed to load resource: ${event.target.src || event.target.href}`,
                options: {
                    level: 'warning',
                    tags: { type: 'resource_load' },
                    fingerprint: ['RESOURCE_LOAD', event.target.tagName], // Группируем по типу тега (IMG, SCRIPT и т.д.)
                    extra: {
                        tagName: event.target.tagName,
                        src: event.target.src || event.target.href,
                        inDOM: document.contains(event.target)
                    }
                }
            };

            try {
                if (navigator.onLine) {
                    window.Sentry.captureMessage(errorData.message, errorData.options);
                } else {
                    SentryErrorQueue.add(errorData);
                }
            } catch (e) {
                SentryErrorQueue.add(errorData);
            }
        } else if (event.error) {
            const errorData = {
                type: 'exception',
                error: event.error,
                options: {
                    extra: {
                        stack: event.error.stack,
                        timestamp: new Date().toISOString()
                    }
                }
            };

            try {
                if (navigator.onLine) {
                    window.Sentry.captureException(errorData.error, errorData.options);
                } else {
                    SentryErrorQueue.add(errorData);
                }
            } catch (e) {
                SentryErrorQueue.add(errorData);
            }
        }
    }, true);
}

export function setupConnectionHandlers() {
    window.addEventListener('online', () => {
        console.log('Connection restored - sending queued errors');
        SentryErrorQueue.process();
    });

    setInterval(() => SentryErrorQueue.process(), 300000);
}
